import { required, Validator } from '@/entities/validation';
import { OptionSetForm } from './model';

export const validate: Validator<OptionSetForm> = record => [
  ...required(record.name, 'name'),
  ...(record.optionValues.length === 0 ? required('', 'optionValues') : []),
  ...record.optionValues.flatMap((option, index) =>
    required(option.label, `optionValues.${index}.label`)),
];
